"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
const AccountIdentity_dto_1 = require("./AccountIdentity.dto");
class AccountDto {}
exports.AccountDto = AccountDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AccountDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AccountDto.prototype, "email", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], AccountDto.prototype, "telephone", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.AccountRole
}), __metadata("design:type", String)], AccountDto.prototype, "role", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.AccountStatus
}), __metadata("design:type", String)], AccountDto.prototype, "status", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.IdentityProvider,
  isArray: true
}), __metadata("design:type", Array)], AccountDto.prototype, "identityProviders", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: () => AccountIdentity_dto_1.AccountIdentityDto,
  isArray: true
}), __metadata("design:type", Array)], AccountDto.prototype, "identities", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: 'string',
  nullable: true
}), __metadata("design:type", Object)], AccountDto.prototype, "imageUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AccountDto.prototype, "firstName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AccountDto.prototype, "lastName", void 0);
//# sourceMappingURL=Account.dto.js.map